import { render, staticRenderFns } from "./salothercostview.vue?vue&type=template&id=dd04db0e&scoped=true&"
import script from "./salothercostview.vue?vue&type=script&lang=js&"
export * from "./salothercostview.vue?vue&type=script&lang=js&"
import style0 from "./salothercostview.vue?vue&type=style&index=0&id=dd04db0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd04db0e",
  null
  
)

export default component.exports